import factory from './icon';
import Svg from './glyphs/doggieLogo.svg';

export default factory(Svg);
